import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import { MainToolbarComponent } from './components/main-toolbar/main-toolbar.component';
import { SwUpdate } from '@angular/service-worker';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    MainToolbarComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'G Z ADMIN';

  public get version() { return environment.version; };
  
  environment = environment;
  constructor(
    //private appInit: AppInitializationService,
    //private meta: Meta,
    private titleService: Title,
    private swUpdate: SwUpdate,
    //public router: Router,
    //private pcsetService: PcsetService,
    //private renderer: Renderer2,
    //private dialog: MatDialog
  ) {
    console.log("Version: ", this.version);
    this.checkForUpdates();
  }

  ngAfterViewInit() {
    if ( !environment.production ) {
      this.titleService.setTitle('DEV - GZ ADMIN');
    }
  }

  private async checkForUpdates() {
    if (this.swUpdate.isEnabled) {
      try {
        const updateFound = await this.swUpdate.checkForUpdate();
        if (updateFound /*&& confirm('A new version of this app is available. Do you want to download it?')*/) {
          await this.swUpdate.activateUpdate();
          document.location.reload();
        }
      } catch (error) {
        console.error('Error while checking for updates:', error);
      }
    } else {
      console.warn('Service Worker is not enabled.');
    }
  }
  
}
